
/** 登陆类型枚举 */
export enum LoginAccessType {
  /** 微信auth2授权登陆 */
  auth = '0',
  /** 小程序登陆 */
  minProgram = '1',
  /** token登陆 */
  token = '2'
}

const REPORTED_FLAG_KEY = 'login_firstScreenTiming_reported';
/**
 * 测速数据上报状态缓存处理
 */
export const reportStateCache = {
  /** 判断是否已上报该类数据，只上报一次 */
  checkIsReported() {
    return sessionStorage.getItem(REPORTED_FLAG_KEY) === '1';
  },
  /** 缓存上报标记 */
  saveIsReported() {
    sessionStorage.setItem(REPORTED_FLAG_KEY, '1');
    return this.checkIsReported();
  },
};

// 不同域名下的cookie设置
const cookieSetting = {
  'moneydata.hk': { domain: 'moneydata.hk', path: '/' },
  'prom.wechatpay.com.hk': { domain: 'wechatpay.com.hk', path: '/' },
  'bill-payment.wechatpay.com.hk': { domain: '', path: '' },
  'apps.wechatpay.com.hk': { domain: 'apps.wechatpay.com.hk', path: '/' },
};

/** 获取站点cookie设置信息 */
function getCookieSetting() {
  const { host } = location;
  let setting = { domain: host, path: '/' };
  Object.keys(cookieSetting).forEach((key) => {
    if (host.includes(key)) {
      setting = cookieSetting[key];
    }
  });
  return setting;
}

/**
 * 清除cookie中的login_access_type
 */
function clearLoginTypeCookie() {
  const expires = 'Thu, 01 Jan 1970 00:00:00 UTC';
  const { domain, path } = getCookieSetting();
  document.cookie = `login_access_type=; expires=${expires}; domain=${domain}; path=${path};`;
}

/** 缓存cookie获取状态 */
const cacheFetchCookie: { isFetched: boolean, value: string } = {
  isFetched: false,
  value: '',
};

/**
 *  从cookie中获取登陆类型
 * @returns
 */
export function getTypeFromCookie() {
  if (!cacheFetchCookie.isFetched) {
    const match = document.cookie.match(/login_access_type=([^;]+)/);
    cacheFetchCookie.value = match ? match[1] : '';
    cacheFetchCookie.isFetched = true;
    // 获取到cookie后立即清除
    clearLoginTypeCookie();
  }
  return cacheFetchCookie.value;
}
